import React, { useEffect, useState } from "react";
import MultilineTextEllipses from "../MultilineTextEllipses/MultilineTextEllipses";
import classes from "./Cart.module.css";
import {
  capitalizeFirstLetter,
  getDateFromTime,
  getDiffDays,
  getShippingStatus,
  getShippingStatusForButtons,
  getShipment,
} from "../../../store/utility";
import * as actions from "../../../store/actions/index";
import { connect } from "react-redux";
import { constants } from "../../../firebase/firestoreNameSpaces";
import Modal from "../Modal/Modal";
import SimpleRating from "../Rating/SimpleRating";
import SimpleGetRating from "../Rating/SimpleGetRating";
import WriteReviewModal from "../Modal/writeReviewModal";
import QuillEditor from "../QuillEditor/QuillEditor";
//Order Row Component For Client Side.
const OrderRow = (props) => {
  const [returnModal, setReturnModal] = useState(false);
  const [cancelReturnModal, setCancelReturn] = useState(false);
  const [ShippingStatus, setShippingStatus] = useState("");
  const [ShippingStatusForButtons, setShippingStatusForButtons] = useState("");
  const [rating, setRating] = useState(null);
  const [review, setReview] = useState("");
  const [reviewHeadline, setReviewHeadline] = useState("");
  let product = props.product;
  let order = props.order;
  let productId = product.variantId ? product.variantId : product.id;

  // let packageStatus = order.packageStatus[id];
  let waybill = product.waybill;
  let packageStatus = null;
  if (waybill) {
    packageStatus = order.packageStatus[waybill];
  }

  let coupon = order.coupon
    ? Math.round(order.coupon.netDiscount / order.products.length)
    : 0;
  // console.log(packageStatus)

  useEffect(async () => {
    try {
      // let response  =  await getShipment(product,order)

      // let Shipment = response.ShipmentData[0].Shipment;

      // if(Shipment){
      //     // console.log(Shipment.Status)
      //     let { StatusType,Status} = Shipment.Status;
      //     setShippingStatus(Status);
      //     // setShippingStatusForButtons(StatusType+"_"+Status)
      //     setShippingStatusForButtons("DL_Delivered")

      // }else{
      //     //Tracking still not available
      //     return ""
      // }
      let { StatusType, Status } = await getShipment(product, order);
      setShippingStatus(Status);
      setShippingStatusForButtons(StatusType + "_" + Status);
      // setShippingStatusForButtons("DL_Delivered");

      if (packageStatus) {
        if (packageStatus) {
          let packaage = packageStatus;
          if (packaage.rating) {
            setRating(packaage.rating);
          }
          if (packaage.review) {
            setReview(packaage.review);
          }
          if (packaage.reviewHeadline) {
            setReviewHeadline(packaage.reviewHeadline);
          }
        }
      }
    } catch (error) {
      return "";
    }
  }, []);

  // console.log(product)
  let display = "d-block";
  const getAttributes = () => {
    let attrs = [];
    if (product.attributes) {
      let attributes = product.attributes;
      for (let attrkey in attributes) {
        attrs.push(
          <div>
            <strong>
              {capitalizeFirstLetter(attributes[attrkey].attribute)}
            </strong>
            : {attributes[attrkey].name}
          </div>
        );
      }
      return attrs;
    } else {
      return null;
    }
  };

  const handleCancelOrder = (product, order) => {
    let waybill = product.waybill;
    if (!waybill) {
      return "Please Try after sometime..";
    }

    // let id = product.variantId?product.variantId:product.id;
    // let waybill = order.packageStatus[wa].waybill;
    props.onCancelOrder(order, product, waybill);
  };

  const handleReturn = (product, order) => {
    let waybill = product.waybill;
    if (!waybill) {
      return "Please Try after sometime..";
    }
    // let id = product.variantId?product.variantId:product.id;
    // let waybill = order.packageStatus[id].waybill;

    let coupon = order.coupon
      ? Math.round(order.coupon.netDiscount / order.products.length)
      : 0;
    let totalRefund = product.salePrice - coupon;
    product.totalRefund = totalRefund;

    props.onReturnOrder(order, product, waybill);
  };

  const handleCancelReturn = (product, order) => {
    let waybill = product.waybill;
    if (!waybill) {
      return "Please Try after sometime..";
    }

    // let id = product.variantId?product.variantId:product.id;
    // let waybill = order.packageStatus[id].waybill;
    props.onCancelReturn(order, product, waybill);
  };

  const handleRatingChange = (newRating) => {
    setRating(newRating);
  };

  const handleSubmitReview = (e, order) => {
    e.preventDefault();

    let userId = props.userId;
    props.onPostReview(userId, order, product, rating, review, reviewHeadline);
  };

  //  let ShippingStatusForButtons = getShippingStatusForButtons(product);
  //  let ShippingStatus = getShippingStatus(product);
  return (
    <div className={`container ${classes.Row}`}>
      <div className="text-center">
        <b>
          {" "}
          <label style={{ fontSize: "12px" }}>OrderId: {order.receipt}</label>
        </b>
      </div>
      <div className={`d-flex flex-nowrap  p-2  justify-content-around`}>
        <div className={classes.ProductImageLeft}>
          <img
            src={product.previewImages[0]}
            style={{ width: "90px", height: "90px" }}
          />
        </div>

        <div className={classes.ItemRight}>
          <div className={classes.Desc}>
            <MultilineTextEllipses>
              <a href="#">{product.productTitle}</a>
            </MultilineTextEllipses>

            {getAttributes()}
          </div>
          <div className={classes.Counter}>
            <div>
              <label className="d-block">Rs. {product.salePrice}</label>
              <label className="d-block">Quantity: {product.quantity}</label>
            </div>

            <div>
              <label>Order Placed On: {getDateFromTime(order.timestamp)}</label>
            </div>
          </div>
        </div>

        <div
          className="d-flex flex-column justify-content-between"
          style={{ alignItems: "flex-end" }}
        >
          {ShippingStatus && (
            <span class="badge badge-info" style={{ width: "fit-content" }}>
              {ShippingStatus}
            </span>
          )}

          <div className={classes.ProductImageRight}>
            <img
              src={product.previewImages[0]}
              style={{ width: "90px", height: "90px" }}
            />
          </div>

          {packageStatus &&
            !packageStatus.cancelOrderRequest &&
            constants.FORWARD_SHIPMENT.CANCELLATION_ALLOWED.includes(
              ShippingStatusForButtons
            ) && (
              <div className={`bottom-line ${display}`}>
                <button
                  className="btn btn-secondary btn-sm mt-0 float-right"
                  data-toggle="modal"
                  data-target={`#co${
                    product.variant ? product.variant : product.id
                  }`}
                >
                  Cancel
                </button>

                {/* ----------------------- Cancel Order Modal starts ----------------------- */}
                <div
                  className="modal fade"
                  tabIndex="-1"
                  role="dialog"
                  id={`co${product.variant ? product.variant : product.id}`}
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div
                    className="modal-dialog"
                    role="document"
                    style={{ marginTop: "25vh" }}
                  >
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">
                          &#9888; Irreversible Action
                        </h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body text-center">
                        Are you sure you want to cancel order ?
                      </div>
                      <div className="modal-footer">
                        <button
                          className="btn btn-secondary btn-sm"
                          onClick={(e) => handleCancelOrder(product, order)}
                          disabled={props.cancelOrderLoading}
                        >
                          {props.cancelOrderLoading ? "Please Wait..." : "Yes"}
                        </button>
                        <button
                          className="btn btn-success btn-sm"
                          data-dismiss="modal"
                          disabled={props.cancelOrderLoading}
                        >
                          No
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* ----------------------- Cancel Order Modal ends ----------------------- */}
              </div>
            )}

          {packageStatus && ShippingStatusForButtons == "DL_Delivered" && (
            <div className="bottom-line">
              {/* <div className="bottom-line float-right" key={order.receipt}>
                    <SimpleRating
                        rating={order.rating}
                        key={Math.random()*10000}
                        readOnly={"readOnly"}
                    // onPostRating={()=>this.props.onPostReview(order.receipt,order.rating,null)}
                    />
                </div> */}

              <div>
                <WriteReviewModal key={productId} receipt={productId}>
                  <React.Fragment>
                    <button className="btn btn-warning btn-sm mt-1 float-right">
                      Rate
                    </button>
                  </React.Fragment>
                  {/* <React.Fragment>{productId}</React.Fragment> */}
                  <div className="text-center">
                    <form>
                      <div
                        // style={{ margin: "4px auto", width: "65%" }}
                        style={{ position: "relative", left: "20vw" }}
                      >
                        <SimpleGetRating
                          key={productId}
                          handleRatingChange={handleRatingChange}
                        />
                      </div>
                      <div className="mt-3 text-left">
                        <label htmlFor="reviewheadline">Add a headline</label>
                        <input
                          type="text"
                          className="form-control"
                          id="reviewheadline"
                          placeholder="What's most important to know?"
                          value={reviewHeadline}
                          required
                          disabled={props.writeReviewLoading}
                          onChange={(e) =>
                            setReviewHeadline(e.target.value.trim())
                          }
                        />
                      </div>
                      <div className="mt-3 text-left">
                        <label htmlFor={productId}>Add a Written Review</label>
                        {/* <textarea
                                className="form-control"
                                name="review"
                                id={`${productId}`}
                                // placeholder="Please write a review for us!"
                                placeholder="What did you like or dislike? What did you use this product for?"
                                rows="3"
                                onChange={(e)=>setReview(e.target.value)}
                                value={review}
                                disabled={props.writeReviewLoading}
                                style={{ marginTop: "10px" }}
                                required
                                ></textarea> */}
                        <QuillEditor
                          value={review}
                          setValue={(value) => setReview(value.trim())}
                        />
                      </div>
                    </form>
                  </div>
                  <div style={{ display: "inline" }}>
                    <button
                      className="btn btn-success btn-sm"
                      onClick={(e) => handleSubmitReview(e, order)}
                      disabled={rating === null || props.writeReviewLoading}
                    >
                      {props.writeReviewLoading ? "Saving" : "Submit"}
                    </button>
                  </div>
                </WriteReviewModal>

                {!packageStatus.returnRequest &&
                  getDiffDays(order.timestamp, new Date().getTime()) <=
                    constants.RETURN_POLICY && (
                    <button
                      className="btn btn-sm btn-primary  m-1 float-right"
                      onClick={() => setReturnModal(true)}
                    >
                      Return
                    </button>
                  )}
              </div>

              <div>
                {returnModal && (
                  <Modal
                    show={returnModal}
                    modalClosed={() => setReturnModal(false)}
                    modalStyle={{
                      width: "80%",
                      left: "4%",
                      overflowY: "scroll",
                      maxHeight: "70%",
                      top: "15%",
                    }}
                  >
                    <div>
                      <h6>Are you sure you want to return the product?</h6>
                      <hr></hr>
                      <p
                        className="d-flex flex-column align-items-center"
                        align="justify"
                      >
                        <label>Product Price: {product.salePrice}</label>
                        {order.coupon && <label>Coupon: {coupon}</label>}
                        <label>
                          Total Refund: {product.salePrice - coupon}
                        </label>
                      </p>
                    </div>
                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary btn-sm"
                        onClick={(e) => handleReturn(product, order)}
                        disabled={props.cancelOrderLoading}
                      >
                        {props.cancelOrderLoading ? "Please Wait..." : "Yes"}
                      </button>
                      <button
                        className="btn btn-success btn-sm"
                        // data-dismiss="modal"
                        onClick={() => setReturnModal(false)}
                      >
                        No
                      </button>
                    </div>
                  </Modal>
                )}
              </div>
            </div>
          )}

          {packageStatus &&
            constants.BACKWARD_SHIPMENT.CANCELLATION_ALLOWED.includes(
              ShippingStatusForButtons
            ) &&
            packageStatus.returnRequest && (
              <div className="bottom-line d-block">
                <button
                  className="btn btn-sm btn-secondary mt-0 float-right"
                  onClick={() => setCancelReturn(true)}
                >
                  Cancel Return
                </button>

                <div>
                  {cancelReturnModal && (
                    <Modal
                      show={returnModal}
                      modalClosed={() => setCancelReturn(false)}
                      modalStyle={{
                        width: "80%",
                        left: "4%",
                        overflowY: "scroll",
                        maxHeight: "70%",
                        top: "15%",
                      }}
                    >
                      <div>
                        <h6>Are you sure you want to Cancel Return?</h6>
                      </div>
                      <div className="modal-footer">
                        <button
                          className="btn btn-secondary btn-sm"
                          onClick={(e) => handleCancelReturn(product, order)}
                          disabled={props.cancelOrderLoading}
                        >
                          {props.cancelOrderLoading ? "Please Wait..." : "Yes"}
                        </button>
                        <button
                          className="btn btn-success btn-sm"
                          // data-dismiss="modal"
                          onClick={() => setCancelReturn(false)}
                        >
                          No
                        </button>
                      </div>
                    </Modal>
                  )}
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    userId: state.auth.userId,
    cancelOrderLoading: state.bookings.cancelOrderLoading,
    writeReviewLoading: state.review.writeReviewLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addProductToCartSync: (
      userId,
      product,
      action,
      includeDeliveryComputation
    ) =>
      dispatch(
        actions.addProductSyncronously(
          userId,
          product,
          action,
          includeDeliveryComputation
        )
      ),
    onRemoveProductFromCart: (userId, product, includeDeliveryComputation) =>
      dispatch(
        actions.removeProductFromCart(
          userId,
          product,
          includeDeliveryComputation
        )
      ),
    onCancelOrder: (order, product, waybill) =>
      dispatch(actions.onCancelOrder(order, product, waybill)),
    onReturnOrder: (order, product, waybill) =>
      dispatch(actions.returnOrder(order, product, waybill)),
    onCancelReturn: (order, product, waybill) =>
      dispatch(actions.cancelReturn(order, product, waybill)),
    onPostReview: (userId, order, product, rating, review, reviewHeadline) =>
      dispatch(
        actions.onPostReview(
          userId,
          order,
          product,
          rating,
          review,
          reviewHeadline
        )
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(OrderRow);
